/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRectangleRoundedBottom = createReactComponent("outline", "rectangle-rounded-bottom", "IconRectangleRoundedBottom", [["path", { "d": "M9 18h6a6 6 0 0 0 6 -6v-5a1 1 0 0 0 -1 -1h-16a1 1 0 0 0 -1 1v5a6 6 0 0 0 6 6z", "key": "svg-0" }]]);

export { IconRectangleRoundedBottom as default };
//# sourceMappingURL=IconRectangleRoundedBottom.mjs.map
